import { render, staticRenderFns } from "./Spoiler.vue?vue&type=template&id=2b421d9c&scoped=true&"
import script from "./Spoiler.vue?vue&type=script&lang=js&"
export * from "./Spoiler.vue?vue&type=script&lang=js&"
import style0 from "./Spoiler.vue?vue&type=style&index=0&id=2b421d9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b421d9c",
  null
  
)

export default component.exports